// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"5776553f","643":"0e02bb73","723":"b35019eb","734":"a484f421","862":"0666e3a9"}[chunkId] + ".chunk.js";
};